import Component from '@bythepixel/component-loader';
import runInView from '@bythepixel/run-in-view';

export default class MenuTabs extends Component {
  static selector = '[comp-menu-tabs]'

  constructor(...args) {
    super(...args);
    this.targetId = this.$container.getAttribute('menu-tabs-content-target');
    this.initialTab = this.$container.getAttribute('menu-tabs-initial-tab') || 0;

    this.tabs = [...this.$container.querySelectorAll('[data-tab-index]')].sort(
      (a, b) => Number(a.dataset.tabIndex > b.dataset.tabIndex),
    );
    this.events();
    this.activateInitialTabInView();
  }

  events() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        if (this.activetab === Number(tab.dataset.tabIndex)) return;
        this.deactivateTab();
        this.activetab = Number(tab.dataset.tabIndex);
        this.activateTab();
      });
      tab.addEventListener('focusout', () => {
        this.$publish(`${this.targetId}:leave-container`);
      });
      tab.addEventListener('focus', () => {
        this.$publish(`${this.targetId}:hover-tab`, { element: tab });
      });
      tab.addEventListener('mouseover', () => {
        this.$publish(`${this.targetId}:hover-tab`, { element: tab });
      });
    });

    this.$container.addEventListener('mouseleave', () => {
      this.$publish(`${this.targetId}:leave-container`);
    });
  }

  activateInitialTabInView() {
    const firstTab = this.tabs[this.initialTab];
    runInView(firstTab, () => {
      this.activetab = Number(firstTab.dataset.tabIndex);
      this.activateTab();
    });
  }

  activateTab() {
    this.tabs[this.activetab].classList.add('header-menu-tab--active');
    this.$publish(`${this.targetId}:activate-tab`, {
      index: Number(this.activetab),
      element: this.tabs[this.activetab],
    });
  }

  deactivateTab() {
    this.tabs[this.activetab].classList.remove('header-menu-tab--active');
    this.$publish(`${this.targetId}:deactivate-tab`, { index: Number(this.activetab) });
  }
}
